import React, { useState, useEffect } from "react";
import { SuccessToast, WarningToast } from "../../../../Util";
import { FaCalendarAlt } from "react-icons/fa";
import { GetMonazamDetails, CreateReversalIncomingRequest, GetRegisteredHGOs } from "../../../../Actions/RequestActions";
import TransfersTabs from "../CommonComponents/TransfersTabs";
import TableTransfer from "../MonazamAccount/MonazamAccountComponents/TableTransfer";
import TableUnclaimed from "../MonazamAccount/MonazamAccountComponents/TableUnclaimed";
import "./ReversalIncomingRequest.css";
import {Spinner} from "react-bootstrap";

const ReversalIncomingRequestContainer = () => {
  const [formData, setFormData] = useState({
    currency: "",
    transactionId: "",
    narration: "",
    hajji: "",
    monazamBankAccountId: "",
    amount: "",
    hgoId: ""
  });

  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [bankLoading, setBankLoading] = useState(false);
  const [bankError, setBankError] = useState("");
  const [fcyAccount, setFcyAccount] = useState(null);
  const [hgos, setHgos] = useState([]);
  const [hgoLoading, setHgoLoading] = useState(false);
  const [hgoError, setHgoError] = useState("");

  useEffect(() => {
    GetMonazamDetails(
      (data) => {
        if (data?.bankAccounts && Array.isArray(data.bankAccounts)) {
          setBankAccounts(data.bankAccounts);
        }
        if (data?.user?.fcyBankName) {
          setFcyAccount({
            id: "fcy-user-account",
            accountType: "FCY",
            bankName: data.user.fcyBankName,
            iban: data.user.fcyIban,
            accountTitle: data.user.fcyAccountTitle,
            branchName: data.user.fcyBranchName,
            swiftCode: data.user.fcySwiftCode,
          });
        }
      },
      setBankLoading,
      setBankError
    );

    GetRegisteredHGOs(
      setHgos,
      setHgoLoading,
      setHgoError
    );
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const newData = {
        ...prev,
        [name]: value
      };
      if (name === "currency") {
        newData.monazamBankAccountId = "";
      }
      return newData;
    });
    setValidationErrors(prev => ({
      ...prev,
      [name]: false
    }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};

    if (!formData.currency) errors.currency = true;
    if (!formData.transactionId?.trim()) errors.transactionId = true;
    if (!formData.narration?.trim()) errors.narration = true;
    if (!formData.hajji?.trim()) errors.hajji = true;
    if (formData.currency === "PKR" && !formData.monazamBankAccountId) {
      errors.monazamBankAccountId = true;
    }
    if (!formData.amount || parseFloat(formData.amount.replace(/,/g, '')) <= 0) errors.amount = true;
    if (!formData.hgoId) errors.hgoId = true;

    setValidationErrors(errors);

    if (Object.keys(errors).length === 0) {
      setLoading(true);
      
      let bankName = "";
      if (formData.currency === "PKR" && formData.monazamBankAccountId) {
        const selectedAccount = bankAccounts.find(acc => acc.id === formData.monazamBankAccountId);
        bankName = selectedAccount?.bankName || selectedAccount?.accountTitle || selectedAccount?.iban || "";
      } else if (formData.currency === "USD" && fcyAccount) {
        bankName = fcyAccount.bankName || fcyAccount.accountTitle || "";
      }
      
      if (!bankName) {
        WarningToast("Bank name is required. Please ensure account is selected.");
        setLoading(false);
        return;
      }
      
      const apiData = {
        currency: formData.currency,
        transactionId: formData.transactionId,
        narration: formData.narration,
        haji: formData.hajji,
        bankName: bankName,
        amount: Number(formData.amount.replace(/,/g, '')),
        hgoId: formData.hgoId
      };
      
      if (formData.currency === "PKR" && formData.monazamBankAccountId) {
        apiData.monazamBankAccountId = formData.monazamBankAccountId;
      }
      
      CreateReversalIncomingRequest(
        apiData,
        (errorMessage) => {
          setLoading(false);
          if (errorMessage) {
            WarningToast(errorMessage);
          }
        },
        () => {
          setLoading(false);
          SuccessToast("Reversal incoming request created successfully!");
          setFormData({
            currency: "",
            transactionId: "",
            narration: "",
            hajji: "",
            monazamBankAccountId: "",
            amount: "",
            hgoId: ""
          });
          setValidationErrors({});
        }
      );
    } else {
      WarningToast("Please fill in all required fields.");
    }
  };

  return (
    <div className="container-fluid main-content-table">
      <div className="row">
        <div className="col-12">
          <div className="bg-light p-2 rounded">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <h4 className="mb-0">Reversal Incoming Request</h4>
              </div>
              <div className="d-flex flex-column">
                <label className="form-label small">Date</label>
                <input 
                  type="date" 
                  className="form-control date-input" 
                  value={new Date().toISOString().split('T')[0]} 
                  readOnly
                  onClick={(e) => e.target.showPicker()}
                />
              </div>
            </div>

            <div className="card">
              <div className="card-body p-2">
                
                <form onSubmit={handleSubmit}>
                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label small">Currency *</label>
                      <select
                        className={`form-select ${validationErrors.currency ? 'is-invalid' : ''}`}
                        name="currency"
                        value={formData.currency}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        <option value="PKR">PKR</option>
                        <option value="USD">USD</option>
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small">Transaction ID *</label>
                      <input
                        type="text"
                        className={`form-control ${validationErrors.transactionId ? 'is-invalid' : ''}`}
                        name="transactionId"
                        value={formData.transactionId}
                        onChange={handleChange}
                        placeholder="BTRX/PK/2025/1001/0001"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label small">Hajji *</label>
                      <input
                        type="text"
                        className={`form-control ${validationErrors.hajji ? 'is-invalid' : ''}`}
                        name="hajji"
                        value={formData.hajji}
                        onChange={handleChange}
                        placeholder="Name"
                      />
                    </div>
                    {formData.currency === "PKR" && (
                      <div className="col-md-6">
                        <label className="form-label small">Monazzam Account *</label>
                        {(() => {
                          const pkrAccounts = bankAccounts.filter(acc => acc.accountType === "PKR");
                          const bankDisabled = bankLoading || !formData.currency;
                          
                          return (
                            <div>
                              <select
                                className={`form-select ${validationErrors.monazamBankAccountId ? 'is-invalid' : ''}`}
                                name="monazamBankAccountId"
                                value={formData.monazamBankAccountId}
                                onChange={handleChange}
                                disabled={bankDisabled}
                              >
                                <option value="" disabled hidden>
                                  {bankLoading ? "Loading accounts..." : "Select"}
                                </option>
                                {pkrAccounts.map((account) => (
                                  <option key={account.id} value={account.id}>
                                    {account.bankName || account.accountTitle || account.iban}
                                  </option>
                                ))}
                              </select>
                              {!formData.currency && (
                                <small className="text-muted">
                                  * First select Currency, then select Monazzam Account
                                </small>
                              )}
                            </div>
                          );
                        })()}
                      </div>
                    )}
                  </div>

                  {bankError && (
                    <div className="alert alert-warning mb-2" role="alert">
                      <small>⚠️ {bankError}</small>
                    </div>
                  )}

                  {hgoError && (
                    <div className="alert alert-warning mb-2" role="alert">
                      <small>⚠️ {hgoError}</small>
                    </div>
                  )}

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label className="form-label small">HGO Company *</label>
                      <select
                        className={`form-select ${validationErrors.hgoId ? 'is-invalid' : ''}`}
                        name="hgoId"
                        value={formData.hgoId}
                        onChange={handleChange}
                        disabled={hgoLoading}
                      >
                        <option value="" disabled hidden>
                          {hgoLoading ? "Loading HGOs..." : "Select"}
                        </option>
                        {hgos.map((hgo) => (
                          <option key={hgo.id} value={hgo.id}>
                            {hgo.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small">Amount *</label>
                      <input
                        type="text"
                        className={`form-control ${validationErrors.amount ? 'is-invalid' : ''}`}
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        placeholder="20,555"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-12">
                      <label className="form-label small">Narration *</label>
                      <textarea
                        className={`form-control ${validationErrors.narration ? 'is-invalid' : ''}`}
                        rows="3"
                        name="narration"
                        value={formData.narration}
                        onChange={handleChange}
                        placeholder="Comments"
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button
                      type="submit"
                      className="btn btn-success btn-lg px-5"
                      disabled={loading}
                    >
                        {loading ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Submit"
                        )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReversalIncomingRequestContainer;
